export default __webpack_public_path__ + "static/media/HDTX Pengumuman RUPS GMS Announcement 2026.ae7cb7e8.pdf";